export default "__VITE_ASSET__BPIYGOhV__"